/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} GermanInputs */

const en_german = /** @type {(inputs: GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const fr_german = /** @type {(inputs: GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const de_german = /** @type {(inputs: GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

const it_german = /** @type {(inputs: GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tedesco`)
};

const ru_german = /** @type {(inputs: GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`немецкий`)
};

const es_german = /** @type {(inputs: GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alemán`)
};

const zh_cn2_german = /** @type {(inputs: GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`德语`)
};

const ja_german = /** @type {(inputs: GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドイツ語`)
};

const hi_german = /** @type {(inputs: GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deutsch`)
};

const pt_pt2_german = /** @type {(inputs: GermanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alemão`)
};

/**
* | output |
* | --- |
* | "Deutsch" |
*
* @param {GermanInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const german = /** @type {((inputs?: GermanInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<GermanInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_german(inputs)
	if (locale === "de") return de_german(inputs)
	if (locale === "it") return it_german(inputs)
	if (locale === "ru") return ru_german(inputs)
	if (locale === "es") return es_german(inputs)
	if (locale === "zh-CN") return zh_cn2_german(inputs)
	if (locale === "ja") return ja_german(inputs)
	if (locale === "hi") return hi_german(inputs)
	if (locale === "pt-PT") return pt_pt2_german(inputs)
	return en_german(inputs)
});